
/// <amd-module name="Search/Code/Components/BranchFilter/BranchSelectorFooter" />
import * as React from "react";
import * as Resources from "Search/Code/Components/BranchFilter/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { VssComponent } from "VSS/Platform/Layout";
import { getGitClient } from "VC/Common/RestClient/Git";
import { routeUrl } from "VSS/Platform/Location";
import { FPSLinkComponent } from "VSS/Platform/Components/FPSLink";

export interface IBranchSelectorFooterProps {
    project: string;

    repositoryName: string;
}

export interface IBranchSelectorFooterState {
    repositoryId: string | undefined;
}

export class BranchSelectorFooter extends VssComponent<IBranchSelectorFooterProps, IBranchSelectorFooterState> {
    constructor(props: IBranchSelectorFooterProps) {
        super(props);
        this.state = { repositoryId: undefined };
    }

    public render(): JSX.Element {
        const repositoryId = this.state.repositoryId || "";
        const { project } = this.props;
        const url = routeUrl(
            this.context.pageContext,
            "ms.vss-admin-web.project-admin-hub-route",
            {
                adminPivot: "repositories",
                "_a": "options",
                repositoryId,
                project
            }
        );

        return (
            <FormatComponent format={Resources.BranchFilterFooterFormat}>
                {
                    <FPSLinkComponent href={url}>
                        {Resources.BranchFilterFooterLink}
                    </FPSLinkComponent>
                }
            </FormatComponent>
        );
    }

    public componentDidMount(): void {
        this.fetchRepositoryId(this.props.project, this.props.repositoryName);
    }

    public componentWillReceiveProps(nextProps: IBranchSelectorFooterProps): void {
        if (this.props.project !== nextProps.project &&
            this.props.repositoryName !== nextProps.repositoryName) {
            this.fetchRepositoryId(nextProps.project, nextProps.repositoryName);
        }
    }

    private async fetchRepositoryId(project: string, repoName: string): Promise<void> {
        const gitRepo = repoName.indexOf("$/") < 0;
        if (gitRepo) {
            const repository = await getGitClient(this.context.pageContext).getRepository(repoName, project);
            this.setState({ repositoryId: repository.id });
        }
    }
}

VssComponent.register("search.code.branchSelectorFooter", BranchSelectorFooter);
